import { render, staticRenderFns } from "./PosturasCategoryContainer.vue?vue&type=template&id=10b5d500"
import script from "./PosturasCategoryContainer.vue?vue&type=script&lang=js"
export * from "./PosturasCategoryContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports